import { Injectable, Inject } from '@angular/core';
import { Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class SmartsuppService {
  private renderer: Renderer2;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    // Initialisation du Renderer2 via le RendererFactory2
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  /**
   * Méthode pour charger le script Smartsupp
   * @param key - Clé d'accès Smartsupp
   * @param orientation - Orientation du chat (left ou right)
   */
  loadSmartsupp(key: string, orientation: string = 'left'): void {
    if (!this.isScriptLoaded('smartsupp-script')) {
      // Définir les paramètres Smartsupp
      const smartsuppConfig = `
        var _smartsupp = _smartsupp || {};
        _smartsupp.key = '${key}';
        _smartsupp.orientation = '${orientation}';
      `;

      // Ajouter le script Smartsupp au body
      const script = this.renderer.createElement('script');
      script.type = 'text/javascript';
      script.id = 'smartsupp-script';
      script.async = true;

      script.text = `
        ${smartsuppConfig}
        window.smartsupp||(function(d) {
          var s,c,o=smartsupp=function(){ o._.push(arguments)};o._=[];
          s=d.getElementsByTagName('script')[0];c=d.createElement('script');
          c.type='text/javascript';c.charset='utf-8';c.async=true;
          c.src='https://www.smartsuppchat.com/loader.js?';
          s.parentNode.insertBefore(c,s);
        })(document);
      `;
      this.renderer.appendChild(this.document.body, script);
    } else {
      console.warn('Smartsupp script is already loaded.');
    }
  }

  /**
   * Méthode pour supprimer le script Smartsupp
   */
  removeSmartsupp(): void {
    const script = this.document.getElementById('smartsupp-script');
    if (script) {
      this.renderer.removeChild(this.document.body, script);
    } else {
      console.warn('Smartsupp script is not found.');
    }
  }

  /**
   * Vérifie si le script Smartsupp est déjà chargé
   * @param id - L'identifiant unique du script
   * @returns boolean - true si le script est chargé
   */
  private isScriptLoaded(id: string): boolean {
    return !!this.document.getElementById(id);
  }
}
